module.exports = __webpack_public_path__ + "assets/img/orderbg.933c492c.png";